export default __webpack_public_path__ + "static/media/web_design.d98a97ac.jpg";